/*
 * Actions belong to the TITLE, not to the bottom of whatever the identity
 * block happens to contain. Under `flex-end` a header carrying a stat row
 * dropped its primary button 113px below the heading it acts on, so the two
 * read as unrelated. `flex-start` keeps them on one line at every content
 * height; the row grows downward from a fixed top edge.
 */
.header {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-6);
  padding-bottom: var(--space-5);
  border-bottom: 1px solid var(--line-strong);
}

.header::after {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: var(--space-12);
  height: 1px;
  background: var(--accent);
  content: '';
}

.identity {
  display: grid;
  gap: var(--space-2);
  min-width: 0;
}

.eyebrow {
  color: var(--accent);
  font-family: var(--font-display);
  font-size: var(--text-2xs);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
}

.title {
  color: var(--ink-primary);
  font-size: var(--text-2xl);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
}

.description {
  max-width: var(--measure-prose);
  color: var(--ink-secondary);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
}

.meta {
  margin-top: var(--space-2);
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-2);
  flex-wrap: wrap;
  flex-shrink: 0;
}

@media (width <= 44rem) {
  .header {
    align-items: stretch;
    flex-direction: column;
    gap: var(--space-4);
  }

  .actions {
    justify-content: flex-start;
  }
}
